/* src/app/main/pages/documents/bl-terms-conditions/bl-terms-conditions.component.css */
.docs-page {
  box-shadow: 0px 0px 3px #ccc;
}
.docs-page h4,
.docs-page h3 {
  font-size: 19px;
  padding: 10px 0;
}
/*# sourceMappingURL=bl-terms-conditions.component.css.map */
